module.exports = __webpack_public_path__ + "img/weekend.b7a20807.jpg";